import { NotificationCard } from '../notification-card';
import NotificationInternal from './notification-internal';
import ActionButton from './action-button';
var NotificationNamespace = Object.assign(NotificationInternal, {
    ActionButton: ActionButton,
    CloseButton: NotificationCard.CloseButton,
});
export default NotificationNamespace;
